import React from "react";
import { Button, Icon } from "aible";
import { Popover, OverlayTrigger } from "react-bootstrap";

import styles from "./style.module.css";

const COLORS = {
  blueprint: "#4A90E2",
  project: "#7E69D7",
  deployment: "#512F77",
  red: "#C03E5A",
  green: "#54C06C",
  default: "C8CAD4"
};

const ICONS = {
  blueprint: "blueprintWhite"
};

export default class TileItem extends React.PureComponent {
  render() {
    const { className, icon, onClick, overlay, overlayTitle, children, hide, centerText, smallOverlay, ...retProps } =
      this.props;

    if (hide) {
      return <React.Fragment />;
    }

    return (
      <div className={styles.tileItemWrapper + " " + (className ? className : "")} {...retProps}>
        <TileItemIcon icon={icon} />
        <OverlayTrigger
          placement="top"
          trigger={overlay ? (smallOverlay ? ["hover"] : ["click"]) : []}
          rootClose
          overlay={
            <Popover id="popover-positioned-top" title={overlayTitle}>
              <div className={styles.tileOverlay + " " + (smallOverlay ? styles.isSmall : "")}>{overlay}</div>
            </Popover>
          }
        >
          <div
            className={
              styles.tileItemText +
              " " +
              (onClick || (overlay && !smallOverlay) ? styles.isLink : "") +
              " " +
              (centerText ? styles.isCenter : "")
            }
            onClick={onClick}
          >
            {children}
          </div>
        </OverlayTrigger>
      </div>
    );
  }
}

class TileItemIcon extends React.PureComponent {
  render() {
    const { icon } = this.props;
    if (!icon) {
      return <React.Fragment />;
    }

    return (
      <div className={styles.tileIconWrapper}>{typeof icon === "string" ? <Icon type={icon} size={16} /> : icon}</div>
    );
  }
}
